import React, { memo, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Stack, Typography, Icon, Card, CardContent, Box } from "investira.react.components";
import { BaseTemplate, PaginationTemplate } from "../../components/templates";
import { SearchAtivos } from "../../components/organisms";
import { PATHS } from "../../enums";
const ListaAtivos = memo(props => {
  const location = useLocation();
  const [isPageLoading] = useState(false);
  const ATIVO_MERCADO = {
    FND: {
      id: "FND",
      label: "Fundo de Investimento",
      iconName: "fund",
      path: PATHS.fnd.path,
      descricao: "Pesquise e descubra todos os fundos de investimento disponíveis no mercado brasileiro. Filtre por categoria, rentabilidade, volatilidade, patrimônio líquido e outros critérios. Encontre fundos de renda fixa, multimercados, ações e mais, com análises detalhadas para tomar decisões informadas."
    },
    TPU: {
      id: "TPU",
      label: "Título Público",
      iconName: "pub_bond",
      path: PATHS.tpu.path,
      descricao: "Tudo sobre títulos públicos federais, como Tesouro Direto. Confira cotações históricas, rentabilidade, taxas de juros, duration e gráficos de desempenho. Invista em títulos públicos com segurança e acompanhe o desempenho do mercado de dívida pública brasileira."
    },
    TPR: {
      id: "TPR",
      label: "Título Privado",
      iconName: "pri_bond",
      path: PATHS.tpr.path,
      descricao: "Conheça os títulos privados, como debêntures, commercial papers e CRI/CRA. Acesse informações sobre rentabilidade, riscos, prazos e emissoras. Encontre opções de renda fixa privada para potencializar seus investimentos com segurança e transparência."
    },
    TBA: {
      id: "TBA",
      label: "Título Bancário",
      iconName: "bank_bond",
      path: PATHS.tba.path,
      descricao: "Tudo sobre títulos bancários, como CDBs, LCIs, LCAs e outros produtos de renda fixa oferecidos por bancos. Veja taxas de juros, prazos, liquidez, garantias e comparativos de rentabilidade. Escolha os melhores títulos bancários para diversificar sua carteira de investimentos."
    },
    ACN: {
      id: "ACN",
      label: "Ação",
      iconName: "stock",
      path: PATHS.acn.path,
      descricao: "Tudo sobre as ações listadas na bolsa de valores (B3). Confira cotações em tempo real, indicadores fundamentais, desempenho histórico, dividendos e muito mais. Encontre as melhores oportunidades de investimento em ações brasileiras e internacionais."
    }
    // CRP: { id: 'CRP', descricao: 'Criptomoeda', codigo: 2 ^ 10 },
  };
  return <BaseTemplate title={"Lista de Ativos"} subtitle={props.subtitle} description="Listas de ativos do mercado financeiro! Fundos, títulos públicos, títulos bancários, ações, fundos imobiliários, BDRs, ETFs, tesouro direto e outros mais." searchComponent={<SearchAtivos pageIsLoading={isPageLoading} clearOnClose={true} />} maxWidth={"xl"}>
      <Box role="list" aria-label="Lista completa de ativos financeiros disponíveis para investimento" sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)"
      },
      gap: "16px 16px"
    }}>
        {Object.values(ATIVO_MERCADO).map(option => <Link to={`${location.pathname}${option.path}`} aria-label={`Ver lista de ${option.label}`}>
            <Card sx={{
          height: "100%",
          display: "flex"
        }}>
              <CardContent sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flexGrow: 1,
            p: 3
          }}>
                <Stack gap="16px">
                  <Icon iconName={option.iconName} color="primary" size={32} />
                  <Stack>
                    <Typography variant="h6" component="h2" color="textPrimary">
                      {option.label}
                    </Typography>
                    <Typography variant="caption" component="h2" color="textPrimary" gutterBottom>
                      {option.descricao}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Link>)}
      </Box>
    </BaseTemplate>;
});
PaginationTemplate.displayName = "PaginationTemplate";
export default ListaAtivos;
